/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {ExternalAdUnitListPageComponent} from './external-ad-unit-list-page.component';

@Component({
  standalone: true,
  imports: [ExternalAdUnitListPageComponent],
  selector: 'adn-external-ad-unit-route-page',
  template: `
    <adn-external-ad-unit-list-page
      [readOnly]="readOnly">
    </adn-external-ad-unit-list-page>
  `
})
export class ExternalAdUnitRoutePageComponent {
  @Input() readOnly = false;
}
